import Vue from 'vue'
import Nprogress from 'nprogress'
import api from '../../../api/apibackend'
import {
  SET_BANKS,
  SET_COMPANY_BANKS,
  FETCH_BANKS_START,
  FETCH_BANKS_END
} from './mutations.type'

import { GET_BANKS, GET_COMPANY_BANKS, CREATE_BANK, UPDATE_BANK, DELETE_BANK, CREATE_COMPANY_BANK, UPDATE_COMPANY_BANK, DELETE_COMPANY_BANK } from './actions.type';

const state = {
  banks: [],
  companyBanks: [],
  loadingBanks: false
}

const getters = {
  banks: state => state.banks,
  companyBanks: state => state.companyBanks,
  loadingBanks: state => state.loadingBanks
}

const mutations = {
  [SET_BANKS] (state, banks) {
    state.banks = banks
  },
  [SET_COMPANY_BANKS] (state, banks) {
    state.companyBanks = banks
  },
  [FETCH_BANKS_START] (state) {
    state.loadingBanks = true
    Nprogress.start()
  },
  [FETCH_BANKS_END] (state) {
    state.loadingBanks = false
    Nprogress.done()
  }
}

const actions = {
  async [GET_BANKS] ({ commit }) {
    try {
      commit(FETCH_BANKS_START)
      const { data } = await api.get('banks')
      if (data) {
        commit(SET_BANKS, data)       
      }
      commit(FETCH_BANKS_END)
      return data
    } catch (err) {
      console.error(err)
      Vue.notify({
        group: 'loggedIn',
        type: 'error',
        text: err.message
      })
      commit(FETCH_BANKS_END)
    }
  },
  async [CREATE_BANK] ({ commit, dispatch }, bank) {
    try {
      commit(FETCH_BANKS_START)
      const { data } = await api.post('banks', bank)
      commit(FETCH_BANKS_END)
      await dispatch(GET_BANKS)
      Vue.notify({
        group: 'loggedIn',
        type: 'success',
        text: '✔️ Banco creado exitosamente'
      })
      return data      
    } catch (err) {
      commit(FETCH_BANKS_END)
      console.error(err)
      Vue.notify({
        group: 'loggedIn',
        type: 'error',
        text: '❌ Ha ocurrido un error al crear el banco'
      })
    }
  },
  async [DELETE_BANK] ({ commit, dispatch }, bankId) {
    try {
      commit(FETCH_BANKS_START)
      const { data } = await api.delete(`banks/${bankId}`)
      commit(FETCH_BANKS_END)
      dispatch(GET_BANKS)
      Vue.notify({
        group: 'loggedIn',
        type: 'success',
        text: '✔️ Banco eliminado exitosamente'
      })
      return data
    } catch (err) {
      commit(FETCH_BANKS_END)
      console.error(err)
      Vue.notify({
        group: 'loggedIn',
        type: 'error',
        text: '❌ Ha ocurrido un error al eliminar el banco'
      })
    }
  },
  async [UPDATE_BANK] ({ commit, dispatch }, bank) {
    try {
      commit(FETCH_BANKS_START)
      const { data } = await api.patch(`banks/${bank.id}`, bank)
      commit(FETCH_BANKS_END)
      dispatch(GET_BANKS)
      Vue.notify({
        group: 'loggedIn',
        type: 'success',
        text: '✔️ Banco actualizado exitosamente'
      })
      return data
    } catch (err) {
      commit(FETCH_BANKS_END)
      console.error(err)
      Vue.notify({
        group: 'loggedIn',
        type: 'error',
        text: '❌ Ha ocurrido un error al actualizar el banco'
      })
    }
  },
  async [GET_COMPANY_BANKS] ({ commit }) {
    try {
      commit(FETCH_BANKS_START)
      const { data } = await api.get('company/banks')
      if (data) {
        commit(SET_COMPANY_BANKS, data)       
      }
      commit(FETCH_BANKS_END)
      return data
    } catch (err) {
      console.error(err)
      Vue.notify({
        group: 'loggedIn',
        type: 'error',
        text: err.message
      })
      commit(FETCH_BANKS_END)
    }
  },
  async [CREATE_COMPANY_BANK] ({ commit, dispatch }, bank) {
    try {
      commit(FETCH_BANKS_START)
      const { data } = await api.post('company/banks', bank)
      commit(FETCH_BANKS_END)
      await dispatch(GET_COMPANY_BANKS)
      Vue.notify({
        group: 'loggedIn',
        type: 'success',
        text: '✔️ Banco creado exitosamente'
      })
      return data      
    } catch (err) {
      commit(FETCH_BANKS_END)
      console.error(err)
      Vue.notify({
        group: 'loggedIn',
        type: 'error',
        text: '❌ Ha ocurrido un error al crear el banco'
      })
    }
  },
  async [DELETE_COMPANY_BANK] ({ commit, dispatch }, bankId) {
    try {
      commit(FETCH_BANKS_START)
      const { data } = await api.delete(`company/banks/${bankId}`)
      commit(FETCH_BANKS_END)
      dispatch(GET_COMPANY_BANKS)
      Vue.notify({
        group: 'loggedIn',
        type: 'success',
        text: '✔️ Banco eliminado exitosamente'
      })
      return data
    } catch (err) {
      commit(FETCH_BANKS_END)
      console.error(err)
      Vue.notify({
        group: 'loggedIn',
        type: 'error',
        text: '❌ Ha ocurrido un error al eliminar el banco'
      })
    }
  },
  async [UPDATE_COMPANY_BANK] ({ commit, dispatch }, bank) {
    try {
      commit(FETCH_BANKS_START)
      const { data } = await api.patch(`company/banks/${bank.id}`, bank)
      commit(FETCH_BANKS_END)
      dispatch(GET_COMPANY_BANKS)
      Vue.notify({
        group: 'loggedIn',
        type: 'success',
        text: '✔️ Banco actualizado exitosamente'
      })
      return data
    } catch (err) {
      commit(FETCH_BANKS_END)
      console.error(err)
      Vue.notify({
        group: 'loggedIn',
        type: 'error',
        text: '❌ Ha ocurrido un error al actualizar el banco'
      })
    }
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
